import {HubspotIcon, IntegrationCard} from "@tinct/web-components";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {useDeleteCrmIntegration, useGetOrganizationById} from "@tinct/core-api";
import {useMemo} from "react";
import {useOAuthPopup} from "../pages/edit-integrations-page/hooks/use-oauth-popup";

export const HubspotIntegration = () => {
  const workspaceId = useGetCurrentWorkspaceId();

  const { mutate: deleteCrmIntegration } = useDeleteCrmIntegration();
  const { openOAuthPopup } = useOAuthPopup({
    organizationId: workspaceId,
    provider: 'hubspot',
  });

  const { data: organization } = useGetOrganizationById({
    id: workspaceId,
    fields: {
      crmIntegrations: {
        fields: {
          id: null,
          providerType: null,
          status: null,
          errorDetails: null,
        }
      }
    }
  }, {
    enabled: !!workspaceId,
  });

  const hubspotIntegration = useMemo(() => {
    return organization?.crmIntegrations?.find(integration => integration.providerType === 'hubspot');
  }, [organization]);

  const connected = !!hubspotIntegration;

  const handleDisconnectHubspot = () => {
    if (!workspaceId || !hubspotIntegration?.id) return;
    deleteCrmIntegration({
      integrationId: hubspotIntegration.id,
      organizationId: workspaceId,
    })
  }

  return <IntegrationCard
    title="Hubspot"
    description="Enrich companies and sync visitor engagement to your CRM"
    status={connected ? "connected" : "not-connected"}
    icon={<HubspotIcon width={40} height={40}/>}
    active={true}
    enabled={connected}
    onEnabledChange={(enabled) => {
      if (enabled) {
        openOAuthPopup();
      } else {
        handleDisconnectHubspot();
      }
    }}
  />
}
